import { LangText } from '@/components';
import { preFixImgUrl } from '@/utils';

const FIRST_ROW_BRANDS = [
  { name: 'top1', image: preFixImgUrl('b3d20bc22537e802856f423ccccdd12e.png') },
  { name: 'top2', image: preFixImgUrl('ca0413febcfae6610fa82152d1bf3c12.png') },
  { name: 'top3', image: preFixImgUrl('ce21b08ba4d29572e67ad3dc9337d0c3.png') },
  { name: 'top4', image: preFixImgUrl('e6bbc56ee7cbc700a2270d2c301d9a09.png') },
  { name: 'top5', image: preFixImgUrl('18b10ede56ed531834421cc5d09580c3.png') },
  { name: 'top6', image: preFixImgUrl('563fb3794dcc47bdb5c621d4fa6eb373.png') },
] as const;

const SECOND_ROW_BRANDS = [
  { name: 'bottom1', image: preFixImgUrl('9740570897abf64f814ecf962ca3c24a.png') },
  { name: 'bottom2', image: preFixImgUrl('5f5bc511b4c1f1795fda062dba4b1195.png') },
  { name: 'bottom3', image: preFixImgUrl('e0e5b7c323f8c16617ece1986054a1d9.png') },
  { name: 'bottom4', image: preFixImgUrl('7fb69bcfb7ac27a4ce60f7b47ea27ead.png') },
  { name: 'bottom5', image: preFixImgUrl('4fe25d8f5893f6304bcfdf1d815b6c1a.png') },
  { name: 'bottom6', image: preFixImgUrl('406dec7da33c61efae1a8dfe3e07a85e.png') },
  { name: 'bottom7', image: preFixImgUrl('29ba9489fa997ef1c022fe74a750aecb.png') },
] as const;

// 第三行品牌图片后续可直接补充到 image 字段。
const THIRD_ROW_BRANDS = [
  { name: 'third1', image: preFixImgUrl('27d6d64fc51c1e0b1e72df7c89c2c8b8.png') },
  { name: 'third2', image: preFixImgUrl('3918ec4e5c2c68fba526b57e8dbe7f1b.png') },
  { name: 'third3', image: preFixImgUrl('d5bd7d0e63d54881c757d59f2c917656.png') },
  { name: 'third4', image: preFixImgUrl('9b109a69bf71f37a58a9004c466656d4.png') },
  { name: 'third5', image: preFixImgUrl('8ff8e77df657c2f1143a9e00c400d40d.png') },
  { name: 'third6', image: preFixImgUrl('5376ea1b6c520074dda1a382b85a6f21.png') },
] as const;

const BRAND_SET_REPEAT_COUNT = 2;

const BrandCard = ({ brand }: { brand: { name: string; image: string } }) => (
  <div className="flex h-[104px] w-[306px] shrink-0 items-center justify-center rounded-[12px] bg-white shadow-[2px_4px_6px_0px_rgba(0,0,0,0.06)]">
    {brand.image ? <img src={brand.image} alt={brand.name} className="object-contain w-full h-full" draggable={false} /> : null}
  </div>
);

const BrandGroup = ({ brands }: { brands: readonly { name: string; image: string }[] }) => (
  <div className="flex shrink-0 gap-[20px] pr-[20px]">
    {Array.from({ length: BRAND_SET_REPEAT_COUNT }).flatMap((_, setIndex) =>
      brands.map((brand) => (
        <BrandCard key={`${setIndex}-${brand.name}`} brand={brand} />
      )),
    )}
  </div>
);

const BrandRail = ({
  brands,
  className,
  direction,
}: {
  brands: readonly { name: string; image: string }[];
  className?: string;
  direction: 'left' | 'right';
}) => (
  <div
    className={`relative left-1/2 w-screen -translate-x-1/2 overflow-hidden py-[2px] ${className || ''}`}
    style={{
      WebkitMaskImage: 'linear-gradient(to right, transparent 0%, #000 12%, #000 88%, transparent 100%)',
      maskImage: 'linear-gradient(to right, transparent 0%, #000 12%, #000 88%, transparent 100%)',
    }}
  >
    <div
      className="flex w-max"
      style={{
        animation: `home-brand-wall-scroll-${direction} 56s linear infinite`,
      }}
    >
      <BrandGroup brands={brands} />
      <BrandGroup brands={brands} />
    </div>
  </div>
);

export const BrandWall = () => {
  return (
    <section className="overflow-hidden pt-[115px]">
      <LangText lngKey="home.brandWall.title" className="block text-center text-[30px] font-bold leading-[42px] text-primary" />

      <BrandRail brands={FIRST_ROW_BRANDS} className="mt-[94px]" direction="left" />
      <BrandRail brands={SECOND_ROW_BRANDS} className="mt-[20px]" direction="right" />
      <BrandRail brands={THIRD_ROW_BRANDS} className="mt-[20px]" direction="left" />

      <style>
        {`
          @keyframes home-brand-wall-scroll-left {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }

          @keyframes home-brand-wall-scroll-right {
            from {
              transform: translateX(-50%);
            }
            to {
              transform: translateX(0);
            }
          }
        `}
      </style>
    </section>
  );
};
